<template>
  <iframe
    :src="m4uRechargeUrl"
    class="w-full min-h-screen flex flex-col items-center justify-center"
  ></iframe>
</template>

<script lang="ts">
import Vue from "vue";
import Constants from "../util/constants";

export default Vue.extend({
  computed: {
    m4uRechargeUrl() {
      const { m4uUrl } = Constants;
      const { token } = this.$route.params;

      return `${m4uUrl}${token}`;
    }
  }
});
</script>
